const requireContext = require.context('../blogs', false, /\.md$/)

const blogs = requireContext.keys().map((key) => {
  const module = requireContext(key)

  let content = module

  if (module && typeof module === 'object' && 'default' in module) {
    content = module.default
  }

  if (typeof content !== 'string') {
    content = String(content)
  }

  const slug = key.replace('./', '').replace('.md', '')

  return {
    slug,
    content
  }
})

export function getBlogBySlug(slug) {
  return blogs.find((b) => b.slug === slug)
}

export function loadBlogs() {
  return blogs
}